import { useEffect, useState } from "react";

import { Observation } from "@medplum/fhirtypes";

import {
  LABOR_QUESTIONNAIRE_DISPLAY_NAMES,
  QuestionnaireType,
} from "@/encounters/components/EncounterLabor/constants/labor-questionnaires";
import { useLaborFlowsheetEditRouteContext } from "@/encounters/components/EncounterLabor/EncounterLaborTable/LaborRow/Common/use-labor-flowsheet-edit-route-context";
import { BirthingFlowsheetDrawer } from "@/encounters/components/EncounterLabor/flowsheet-forms/birthing";

interface EditBirthingLaborRowProps {
  observation: Observation;
  onClose?: () => void;
}

export default function EditBirthingLaborRow({ observation, onClose }: EditBirthingLaborRowProps) {
  const [opened, setOpened] = useState(true);
  const { encounterId, clientId, hasRouteContext } = useLaborFlowsheetEditRouteContext(onClose);
  const questionnaireDisplayName =
    observation.code?.coding?.[0]?.display ??
    LABOR_QUESTIONNAIRE_DISPLAY_NAMES[QuestionnaireType.Birthing];

  useEffect(() => {
    if (hasRouteContext) {
      return;
    }
    setOpened(false);
  }, [hasRouteContext]);

  const handleClose = () => {
    setOpened(false);
    onClose?.();
  };

  if (!hasRouteContext || !encounterId || !clientId) {
    return null;
  }

  return (
    <BirthingFlowsheetDrawer
      mode="edit"
      opened={opened}
      clientId={clientId}
      onClose={handleClose}
      encounterId={encounterId}
      observation={observation}
      title={questionnaireDisplayName}
      questionnaireDisplayName={questionnaireDisplayName}
    />
  );
}
